import * as constants from './constants'

export const externalUserSearchesFetchRequest = payload => ({ payload, type: constants.EXTERNAL_USER_SEARCHES_FETCH_REQUEST })
export const externalUserSearchesFetchSuccess = payload => ({ payload, type: constants.EXTERNAL_USER_SEARCHES_FETCH_SUCCESS })
export const externalUserSearchesFetchFailure = payload => ({ payload, type: constants.EXTERNAL_USER_SEARCHES_FETCH_FAILURE })
